var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18015 11.9315L21.3676 4.63248C21.3775 4.62783 21.384 4.62589 21.3873 4.62508C21.3976 4.63193 21.4101 4.65276 21.411 4.66526C21.4087 4.66805 21.4037 4.67298 21.3952 4.67921L8.67989 14.0152C8.67732 14.0171 8.67483 14.0195 8.67225 14.0214C8.66478 14.0272 8.65722 14.0332 8.64983 14.0395C8.64792 14.041 8.64625 14.0427 8.64459 14.0443C8.62564 14.0611 8.60759 14.0792 8.591 14.0995C8.53783 14.1648 8.50528 14.2399 8.49202 14.3175L7.66458 17.5631L6.18032 11.9318L6.18015 11.9315ZM8.39909 18.4895L9.23011 15.2301L11.2943 16.9155L8.39934 18.4895L8.39909 18.4895ZM27.488 1.19954L18.7541 21.1524C18.7047 21.2657 18.6085 21.347 18.4901 21.3759C18.3717 21.4046 18.2497 21.3767 18.1543 21.2988L12.4703 16.658C12.4479 16.6357 12.4238 16.6159 12.3979 16.599L9.72472 14.4163L21.9507 5.43992C22.3637 5.13685 22.4729 4.59763 22.2107 4.15818C21.9485 3.71872 21.4234 3.56066 20.9619 3.78221L5.69262 11.1205L0.403233 6.80129C0.283417 6.70343 0.298917 6.57413 0.311382 6.52312C0.323677 6.47259 0.367822 6.35142 0.516676 6.31907L27.0102 0.607683C27.2382 0.55816 27.378 0.69377 27.4272 0.754536C27.5314 0.882141 27.5539 1.04849 27.488 1.19954Z",
    fill: "#212936"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanesvg);
export default __webpack_public_path__ + "static/media/Planesvg.57510bdcbe6c2a0eb7908c9abd611c27.svg";
export { ForwardRef as ReactComponent };